import { defineMessages } from 'react-intl';

export const loginMessages = defineMessages({
    welcomeBack: {
        id: 'login-welcome-back',
        defaultMessage: 'Welcome back',
    },
    loginMessage: {
        id: 'login-message',
        defaultMessage: 'Log in to your SmartPark account',
    },
    loginEmailTip: {
        id: 'login-email-tip',
        defaultMessage: 'Use your email to login',
    },
    loginPasswordTip: {
        id: 'login-password-tip',
        defaultMessage: 'Use your password to login',
    },
    login: {
        id: 'login',
        defaultMessage: 'Login',
    },
});

export const forgotPasswordMessages = defineMessages({
    forgotPassword: {
        id: 'forgot-password',
        defaultMessage: 'Forgot your password?',
    },
    forgotPasswordMessage: {
        id: 'forgot-password-message',
        defaultMessage: 'Get back access to your account in no time',
    },
    forgotPasswordEmailTip: {
        id: 'forgot-password-email-tip',
        defaultMessage: 'Enter your email to reset your password',
    },
    forgotPasswordSuccess: {
        id: 'forgot-password-success',
        defaultMessage: 'Check your email for further instructions',
    },
    forgotPasswordSuccessDetails: {
        id: 'forgot-password-success-details',
        defaultMessage: 'We have sent you an email with instructions on how to reset your password',
    },
});

export const resetPasswordMessages = defineMessages({
    resetPassword: {
        id: 'reset-password',
        defaultMessage: 'Reset password',
    },
    resetPasswordMessage: {
        id: 'reset-password-message',
        defaultMessage: 'Enter your new password',
    },
    resetPasswordPasswordTip: {
        id: 'reset-password-password-tip',
        defaultMessage: '8 characters, 1 lowercase, 1 uppercase, 1 number',
    },
    newPassword: {
        id: 'new-password',
        defaultMessage: 'New password',
    },
    confirmNewPassword: {
        id: 'confirm-new-password',
        defaultMessage: 'Confirm new password',
    },
    resetPasswordSuccess: {
        id: 'reset-password-success',
        defaultMessage: 'Password changed',
    },
    resetPasswordSuccessDetails: {
        id: 'reset-password-success-details',
        defaultMessage:
            'Your password has been successfully changed. You will be automatically redirected to the login page.',
    },
});

export const registerMessages = defineMessages({
    welcomeAboard: {
        id: 'register-welcome-aboard',
        defaultMessage: 'Welcome to SmartPark',
    },
    registerMessage: {
        id: 'register-message',
        defaultMessage: 'Lets get you started',
    },
    registerFirstNameTip: {
        id: 'register-first-name-tip',
        defaultMessage: 'Your name, used for identifying you',
    },
    registerLastNameTip: {
        id: 'register-last-name-tip',
        defaultMessage: 'Your last name, used for identifying you',
    },
    registerEmailTip: {
        id: 'register-email-tip',
        defaultMessage: 'Your email used for logging into the system',
    },
    registerPasswordTip: {
        id: 'register-password-tip',
        defaultMessage: '8 characters, 1 lowercase, 1 uppercase, 1 number',
    },
    registerConfirmPasswordTip: {
        id: 'register-confirm-password-tip',
        defaultMessage: 'Type your password again',
    },
    register: {
        id: 'register',
        defaultMessage: 'Register',
    },
    invalidInvitation: {
        id: 'invalid-invitation',
        defaultMessage: 'Invalid or expired invitation!',
    },
});

export const commonMessages = defineMessages({
    firstName: {
        id: 'firstName',
        defaultMessage: 'First name',
    },
    lastName: {
        id: 'lastName',
        defaultMessage: 'Last name',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    firstNamePlaceholder: {
        id: 'first-name-placeholder',
        defaultMessage: 'First name',
    },
    lastNamePlaceholder: {
        id: 'last-name-placeholder',
        defaultMessage: 'Last name',
    },
    emailPlaceholder: {
        id: 'email-placeholder',
        defaultMessage: 'johndoe@smartpark.com',
    },
    password: {
        id: 'password',
        defaultMessage: 'Password',
    },
    confirmPassword: {
        id: 'confirm-password',
        defaultMessage: 'Confirm password',
    },
    slideshowTitleStatistics: {
        id: 'slideshow-title-statistics',
        defaultMessage: 'Business critical statistics',
    },
    slideshowSubtitleStatistics: {
        id: 'slideshow-subtitle-statistics',
        defaultMessage: 'Discover the power of data with our intelligent statistics and widgets',
    },
});

export const permissionMessages = defineMessages({
    accessEntities: {
        id: 'access-entities',
        defaultMessage: 'Access entities',
    },
    manageEntities: {
        id: 'manage-entities',
        defaultMessage: 'Manage entities',
    },
    accessServiceProviders: {
        id: 'access-service-providers',
        defaultMessage: 'Access organisations',
    },
    manageServiceProviders: {
        id: 'manage-service-providers',
        defaultMessage: 'Manage organisations',
    },
    manageSites: {
        id: 'manage-sites',
        defaultMessage: 'Manage sites',
    },
    accessSites: {
        id: 'access-sites',
        defaultMessage: 'Access sites',
    },
    manageZones: {
        id: 'manage-zones',
        defaultMessage: 'Manage zones',
    },
    accessZones: {
        id: 'access-zones',
        defaultMessage: 'Access zones',
    },
    accessGateways: {
        id: 'access-gateways',
        defaultMessage: 'Access gateways',
    },
    manageGateways: {
        id: 'manage-gateways',
        defaultMessage: 'Manage gateways',
    },
    accessSpaces: {
        id: 'access-spaces',
        defaultMessage: 'Access spaces',
    },
    manageSpaces: {
        id: 'manage-spaces',
        defaultMessage: 'Manage spaces',
    },
    manageSystemSettings: {
        id: 'manage-system-settings',
        defaultMessage: 'Manage system settings',
    },
    manageSystemComponents: {
        id: 'manage-system-components',
        defaultMessage: 'Manage system components',
    },
    accessMemberships: {
        id: 'access-memberships',
        defaultMessage: 'Access memberships',
    },
    manageMemberships: {
        id: 'manage-memberships',
        defaultMessage: 'Manage memberships',
    },
    manageMembershipTypes: {
        id: 'manage-membership-types',
        defaultMessage: 'Manage templates',
    },
    accessMembershipTypes: {
        id: 'access-membership-types',
        defaultMessage: 'Access templates',
    },
    accessActiveStays: {
        id: 'access-active-stays',
        defaultMessage: 'Access active stays',
    },
    accessPastStays: {
        id: 'access-past-stays',
        defaultMessage: 'Access past stays',
    },
    accessEventLog: {
        id: 'access-event-log',
        defaultMessage: 'Access event log',
    },
    accessGatewayPasses: {
        id: 'access-gateway-passes',
        defaultMessage: 'Access gateway passes',
    },
    accessVisitors: {
        id: 'access-visitors',
        defaultMessage: 'Access visitors and their identifiers',
    },
    accessAccessKeys: {
        id: 'access-access-keys',
        defaultMessage: 'Access access keys',
    },
    manageAccessKeys: {
        id: 'manage-access-keys',
        defaultMessage: 'Manage access keys',
    },
    accessTroubleshooting: {
        id: 'access-troubleshooting',
        defaultMessage: 'Access troubleshooting',
    },
    accessBillingEntities: {
        id: 'access-billing-entities',
        defaultMessage: 'Access billing entities',
    },
    manageBillingEntities: {
        id: 'manage-billing-entities',
        defaultMessage: 'Manage billing entities',
    },
    accessWhiteLists: {
        id: 'access-white-lists',
        defaultMessage: 'Access white lists',
    },
    manageWhiteLists: {
        id: 'manage-white-lists',
        defaultMessage: 'Manage white lists',
    },
    allowValidations: {
        id: 'allow-validations',
        defaultMessage: 'Allow validations',
    },
    manageValidations: {
        id: 'manage-validations',
        defaultMessage: 'Manage validations',
    },
    accessHomeStats: {
        id: 'access-home-stats',
        defaultMessage: 'Access home stats',
    },
    accessGatewaysMonitoring: {
        id: 'access-gateways-monitoring',
        defaultMessage: 'Access gateways monitoring',
    },
    accessGatewaysMonitoringActions: {
        id: 'access-gateways-monitoring-actions',
        defaultMessage: 'Access gateways monitoring actions',
    },
    accessPayStationsMonitoring: {
        id: 'access-pay-stations-monitoring',
        defaultMessage: 'Access pay stations monitoring',
    },
    accessDevicesMonitoring: {
        id: 'access-devices-monitoring',
        defaultMessage: 'Access devices monitoring',
    },
    accessPaymentStatistics: {
        id: 'access-payment-statistics',
        defaultMessage: 'Access payment statistics',
    },
    accessOccupancyStatistics: {
        id: 'access-occupancy-statistics',
        defaultMessage: 'Access occupancy statistics',
    },
    accessPricingPlans: {
        id: 'access-pricing-plans',
        defaultMessage: 'Access pricing plans',
    },
    managePricingPlans: {
        id: 'manage-pricing-plans',
        defaultMessage: 'Manage pricing plans',
    },
    accessPricingPlanTickRate: {
        id: 'access-pricing-plan-tick-rate',
        defaultMessage: 'Access pricing plans tick rate',
    },
    managePricingPlanTickRate: {
        id: 'manage-pricing-plan-tick-rate',
        defaultMessage: 'Manage pricing plans tick rate',
    },
    accessPricingPlanTiers: {
        id: 'access-pricing-plan-tiers',
        defaultMessage: 'Access pricing plans tiers',
    },
    managePricingPlanTiers: {
        id: 'manage-pricing-plan-tiers',
        defaultMessage: 'Manage pricing plans tiers',
    },
    accessPricingPlanCaps: {
        id: 'access-pricing-plan-caps',
        defaultMessage: 'Access pricing plans caps',
    },
    managePricingPlanCaps: {
        id: 'manage-pricing-plan-caps',
        defaultMessage: 'Manage pricing plans caps',
    },
    accessPricingPlanPeriodAdjustments: {
        id: 'access-pricing-plan-period-adjustments',
        defaultMessage: 'Access pricing plan period adjustments',
    },
    managePricingPlanPeriodAdjustments: {
        id: 'manage-pricing-plan-period-adjustments',
        defaultMessage: 'Manage pricing plans period adjustments',
    },
    accessPayments: {
        id: 'access-payments',
        defaultMessage: 'Access payments',
    },
    accessPayStations: {
        id: 'access-pay-stations',
        defaultMessage: 'Access pay stations',
    },
    managePayStations: {
        id: 'manage-pay-stations',
        defaultMessage: 'Manage pay stations',
    },
    accessPayStationOperations: {
        id: 'access-pay-station-operations',
        defaultMessage: 'Access pay station operations',
    },
    accessPayStationEvents: {
        id: 'access-pay-station-events',
        defaultMessage: 'Access pay station events',
    },
    accessRoles: {
        id: 'access-roles',
        defaultMessage: 'Access roles',
    },
    manageRoles: {
        id: 'manage-roles',
        defaultMessage: 'Manage roles',
    },
    accessUsers: {
        id: 'access-users',
        defaultMessage: 'Access users',
    },
    manageUsers: {
        id: 'manage-users',
        defaultMessage: 'Manage users',
    },
    accessValidationStatistics: {
        id: 'access-validation-statistics',
        defaultMessage: 'Access validation statistics',
    },
});
